// extracted by mini-css-extract-plugin
export default {"time":"FKHGsrDKrUzoCSrODmDd"};